(function () {
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;
  var RESULT_LIMIT = 8;

  function hasFilterSlider() {
    return !!document.querySelector('[data-filter-slider-root]');
  }

  function dispatchLiveSearch(query) {
    document.dispatchEvent(
      new CustomEvent('energize:live-search', {
        detail: { query: query }
      })
    );
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initSmartSearch(root) {
    if (!root || root.dataset.smartSearchInit === 'true') return;

    var input = root.querySelector('[data-header-search-input]');
    var dropdown = root.querySelector('[data-header-search-dropdown]');
    var resultsEl = root.querySelector('[data-header-search-results]');
    var form = root.querySelector('form');

    if (!input || !dropdown || !resultsEl || !form) return;

    root.dataset.smartSearchInit = 'true';

    var debounceTimer = null;
    var abortController = null;
    var activeQuery = '';

    function closeDropdown() {
      dropdown.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function openDropdown() {
      dropdown.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function setLoading() {
      resultsEl.innerHTML = '<p class="header-energize__search-loading">Searching…</p>';
      openDropdown();
    }

    function renderEmpty(query) {
      resultsEl.innerHTML =
        '<p class="header-energize__search-empty">No products found for “' + escapeHtml(query) + '”.</p>';
      openDropdown();
    }

    function renderResults(products, query) {
      if (!products.length) {
        renderEmpty(query);
        return;
      }

      var items = products
        .map(function (product) {
          var image = product.image || (product.featured_image && product.featured_image.url) || '';
          var price = product.price || '';
          return (
            '<li class="header-energize__search-result" role="option">' +
            '<a class="header-energize__search-result-link" href="' +
            escapeHtml(product.url) +
            '">' +
            (image
              ? '<img class="header-energize__search-result-image" src="' +
                escapeHtml(image) +
                '" alt="" loading="lazy" width="52" height="52">'
              : '') +
            '<span class="header-energize__search-result-body">' +
            '<p class="header-energize__search-result-title">' +
            escapeHtml(product.title) +
            '</p>' +
            (price ? '<p class="header-energize__search-result-price">' + escapeHtml(price) + '</p>' : '') +
            '</span>' +
            '</a>' +
            '</li>'
          );
        })
        .join('');

      var searchUrl = form.getAttribute('action') + '?q=' + encodeURIComponent(query) + '&type=product';

      resultsEl.innerHTML =
        '<ul class="header-energize__search-results-list" role="listbox">' +
        items +
        '</ul>' +
        '<a class="header-energize__search-view-all" href="' +
        escapeHtml(searchUrl) +
        '">View all results</a>';

      openDropdown();
    }

    function fetchResults(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=' +
        RESULT_LIMIT +
        '&resources[options][unavailable_products]=hide';

      setLoading();

      fetch(url, { signal: abortController.signal, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Search failed');
          return response.json();
        })
        .then(function (data) {
          if (activeQuery !== query) return;
          var products =
            (data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products) ||
            [];
          renderResults(products, query);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (activeQuery !== query) return;
          renderEmpty(query);
        });
    }

    function handleQueryChange() {
      var query = (input.value || '').trim();
      activeQuery = query;

      if (hasFilterSlider()) {
        dispatchLiveSearch(query);
      }

      clearTimeout(debounceTimer);

      if (query.length < MIN_CHARS) {
        if (abortController) abortController.abort();
        closeDropdown();
        resultsEl.innerHTML = '';
        if (!query.length && hasFilterSlider()) {
          dispatchLiveSearch('');
        }
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, DEBOUNCE_MS);
    }

    input.addEventListener('input', handleQueryChange);

    input.addEventListener('focus', function () {
      if (activeQuery.length >= MIN_CHARS && resultsEl.innerHTML) {
        openDropdown();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) {
        closeDropdown();
      }
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDropdown();
        input.blur();
      }
    });

    form.addEventListener('submit', function () {
      closeDropdown();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-header-smart-search]').forEach(initSmartSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
